import AddPaymentMethod from './add_payment_method';

export default AddPaymentMethod;
